type CsvRow = {
    [key: string]: string;
};

type CsvResult = {
    OK: boolean;
    error?: string;
    file_name?: string;
    rows?: CsvRow[];
};

export async function readCsvMultiple(
    file: File,
    limit: number,
    selectedColumns: string[],
    delimiter = ","
): Promise<CsvResult> {
    try {
        if (!file) {
            return { OK: false, error: "No se recibió archivo." };
        }

        const text = await file.text();
        const lines = text
            .replace(/\r/g, "")
            .split("\n")
            .map(line => line.trim())
            .filter(Boolean);

        if (lines.length === 0) {
            return { OK: false, error: "El archivo CSV está vacío." };
        }

        const header = lines[0].split(delimiter).map(h => h.trim().toLowerCase());

        if (header.length !== selectedColumns.length || header.join(delimiter) !== selectedColumns.join(delimiter)) {
            return {
                OK: false,
                error: `El header del CSV no coincide.\nEsperado: [${selectedColumns.join(", ")}]\nEncontrado: [${header.join(", ")}]`
            };
        }

        const rows = lines.slice(1, 1 + limit).map(line => {
            const cols = line.split(delimiter).map(c => c.trim());
            const obj: any = {};

            selectedColumns.forEach((col, i) => {
                obj[col] = cols[i] ?? "";
            });

            return obj;
        });

        return {
            OK: true,
            file_name: file.name,
            rows
        };
    } catch (e: any) {
        return {
            OK: false,
            error: e?.message ?? "Error desconocido al procesar el CSV."
        };
    }
}
